export const sourceA = [0, 1, 0, 1, 0, 1, 0, 1, 0];
export const sourceB = [
  0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0,
];
